import React, { useEffect, useState } from 'react'
import './App.css';
import { generateMerkleProof } from './whitelist/merkle-tree'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'



function App() {

	const [feedback, setFeedback] = useState(``)

	const [CONFIG, SET_CONFIG] = useState({
		NFTNAME: "SNOW",
		SCAN: "https://etherscan.io"
	})

	const getConfig = async () => {
		const configResponse = await fetch('/config/config.json', {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		})
		const config = await configResponse.json()
		SET_CONFIG(config)
	}

	useEffect(() => {
		getConfig()
	}, [])

	const genProof = () => {
		var address = document.getElementById("address").value;
		const merkleProof = generateMerkleProof(address).toString();
		console.log(merkleProof)
		if (merkleProof.length < 1) {
			setFeedback(`You are not whitelisted!`)
		}
		else {
			setFeedback(`Congrats! You are whitelisted!`)
		}
	}

	return (
		<div className="App">
			<div class="relative flex min-h-screen text-gray-800 antialiased flex-col justify-center overflow-hidden py-6 sm:py-12">
				<div class="relative py-3 sm:w-96 mx-auto text-center">
					<span class="text-2xl text-indigo-500 ">PLAIN WHITELIST CHECKER</span>
					<div class="mt-4 bg-white shadow-md rounded-lg text-left">
						<div class="h-2 bg-indigo-500 rounded-t-md"></div>
						<div class="px-8 py-6 ">
							<label class="block font-semibold text-indigo-500"> Address: </label>
							<input 
							    name="address"
								id="address"
								type="string"
								placeholder="0x0000...." class="border w-full h-5 px-3 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-indigo-500 focus:ring-1 rounded-md" />
								<p className="text-indigo-500 mt-1 text-sm">
								<strong>{feedback}</strong>
							</p>
							<div class="flex justify-between items-baseline">
								<button onClick={(e) => {genProof()}} class="mt-4 bg-indigo-500 text-white py-2 px-6 rounded-md hover:bg-indigo-700 ">Check</button>
							</div>
						</div>

					</div>
				</div>
				<footer>
								<a className="text-indigo-500 mt-1 text-sm" href='https://linktr.ee/reservedsnow'>

									2022 all rights reserved <strong>{CONFIG.NFTNAME}</strong> <br></br>
									Created with <FontAwesomeIcon icon={faHeart} /> by <strong>SnowStudios</strong>
								</a>
							</footer>
			</div>
		</div>
	);
}

export default App;
